<h4 id="upper" class="text-left  mb-4">Configuration</h4>

<body class="d-flex justify-content-center p-4">

  <div class="form-container ">
    <form>
      <div class="mb-3">
        <label for="maxMembres" class="form-label">Nombre maximum de membres</label>
        <input type="number" class="form-control" id="maxMembres" placeholder="Entrez un nombre">
      </div>
      <div class="mb-3">
        <label for="maxAgents" class="form-label">Nombre maximum d'agents de terrain</label>
        <input type="number" class="form-control" id="maxAgents" placeholder="Entrez un nombre">
      </div>
      <div class="mb-3">
        <label class="form-label">Droits de location</label>
        <div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="droitLocation" id="oui" value="oui">
            <label class="form-check-label" for="oui">Oui</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="droitLocation" id="non" value="non">
            <label class="form-check-label" for="non">Non</label>
          </div>
        </div>
      </div>
      <button type="submit" style="background-color:#578D63; color: white;" class="btn w-100">Valider</button>
    </form>
  </div>
</body>
